module.exports = __webpack_public_path__ + "media/assets/images/blog/kanban_cartoon-c8c72649ba302664a4e19555ec628cc2.jpg";